import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { SENSITIVE_DATA_CATEGORIES } from '@omnea-digital/authz-model'
import { z } from 'zod'

extendZodWithOpenApi(z)

export const SensitiveDataCategorySchema = z.enum(SENSITIVE_DATA_CATEGORIES).openapi('Shared.SensitiveDataCategory')

export const HiddenSensitiveDataSchema = z
  .array(SensitiveDataCategorySchema)
  .optional()
  .openapi({ description: 'The sensitive data categories this response masks for the caller' })
